import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-eliminate-event',
  templateUrl: './eliminate-event.page.html',
  styleUrls: ['./eliminate-event.page.scss'],
})
export class EliminateEventPage implements OnInit {

  constructor(private modalController: ModalController) { }

  ngOnInit() {
  }

  close() {
    this.modalController.dismiss('No');
  }
  
  save() {
    this.modalController.dismiss('Yes');
  }

}
